import React from 'react'

import BRAND_COLOURS from '@/constants/BrandColours'
import SUPPORT_COLOURS from '@/constants/SupportColours'

import Icon from '@/components/elements/atoms/Icon/Icon'
import ProgressBar from '@/components/elements/atoms/ProgressBar/ProgressBar'
import Text from '@/components/elements/atoms/Text'

import STYLES from '../../EditRecipes.module.sass'

type Props = {
  percentFilled: number
  boxIsFull: boolean
  boxIsOver: boolean
  totalPouchesAdded: number
  numberOfPouches: number
}

const RecipesProgressBar = ({
  percentFilled,
  boxIsFull,
  boxIsOver,
  totalPouchesAdded,
  numberOfPouches
}: Props): JSX.Element => {
  return (
    <div className={STYLES.progress}>
      <ProgressBar
        fillColour={
          percentFilled === 100
            ? SUPPORT_COLOURS.successGreen400
            : BRAND_COLOURS.brandRed400
        }
        percentFilled={percentFilled}
      />
      <div className={STYLES.counter}>
        {boxIsFull && (
          <Icon accentColour="successGreen400" asset="checkmark" size={20} />
        )}
        {boxIsOver && (
          <Icon accentColour="dangerRed300" asset="errorCircle" size={20} />
        )}
        <Text
          text={`${totalPouchesAdded}/${numberOfPouches}`}
          translate={false}
          margin={false}
        />
      </div>
    </div>
  )
}

export default RecipesProgressBar
